export default "__VITE_ASSET__BZdilBDo__"